import ProjectListContainer from "../../../components/applications/project/projectList";

const ProjectList = () => {
  return <ProjectListContainer />;
};

export default ProjectList;
